import React, { useState, useEffect, useContext } from 'react';
//import PropTypes from 'prop-types';
import SiteWrapper from "../../SiteWrapper.react";
import Select from "react-select";
import { Grid, Button, Icon, Form } from 'tabler-react';
import { Crud_Catalogos, Crud_error } from '../../herramientas/Crud_Catalogos';
import { Exportar } from '../../herramientas/Excel';
import { timeToYearmonthDay } from "../../herramientas/DateFormat";
import * as conf from "../../config/config";
import { softphoneContext } from "../../context/softphoneContext";
import { TablePageable } from "../../Helpers";
import extensiones from './csvjson.json';

const MigrarExtensionesPage = () => {
  const [softphone, setSoftphone]= useState([]);
  useEffect(() => { //traer extensiones
    crud("get", "", "", "softphone_v2/all", "softphone");
  },[]);


  const crud=(metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
    return Crud_Catalogos(catalogo, "movimientos", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
        switch (metodo) {
            case "get":
              if( stateVar === "softphone"){
                setSoftphone(returnVal);
              }
            case "post":
              if( stateVar === "crear_agente"){
                crud("get", "", "", "softphone_v2/all", "softphone");
              }
              
            break;
            default:
                break;
        }
    }).catch(err => { console.log(err); });
  }

  return (
    <SiteWrapper>
      {/*
          {
            name: "",
            lastname: "",
            username: "",
            password: "",
            email: "",
            role: "AGENTE",
            grupo: 0,
            recording: 1
          }
      */}
      <TablePageable
        titulo={<h3>extensiones</h3>}
        lista= { extensiones }
        columnas={
          [
            {  columna: "pendiente",
              label: "Pendiente",
              form:(e)=> softphone.filter(sf=> sf.id === e.id_usuario).length ? "creado": e.username ? "pendiente": "NA",
              valor:(e)=> softphone.filter(sf=> sf.id === e.id_usuario).length ? "creado": e.username ? "pendiente": "NA",
            }, 
            { columna: "crear estension en verion 2", label: "recording",
              form:(e)=>{//crear extension, siempre descragar extensiones e inabilitar botones que ya tengan extension creada
                return <button
                    onClick={()=>{
                      crud("post",
                        {
                          name: e.name,
                          lastname: e.lastname,
                          username: e.username,
                          password: e.username,
                          email: "correo_"+e.id_usuario+"@skyangel.com.mx",
                          role: "AGENTE",
                          grupo: e.grupo,
                          recording: 1
                        },
                        "",
                        "softphone_v2/crear_agente?provedor=2&id="+e.id_usuario+"&idPlataforma="+e.id_plataforma,
                        "crear_agente");
                          }
                    }
                    disabled= {softphone.filter(sf=> sf.id === e.id_usuario).length }
                  > click</button>
              }
            }, 
            { columna: "id_usuario", label: "id" }, 
            { columna: "plataforma", label: "plt" }, 
            { columna: "name", label: "name" }, 
            { columna: "lastname", label: "lastname" }, 
            { columna: "username", label: "username" }, 
            { columna: "username", label: "password" }, 
            { columna: "imail", label: "email", form:(e)=> "correo_"+e.id_usuario+"@skyangel.com.mx"}, 
            { columna: "role", label: "role", form:()=> "AGENTE" }, 
            { columna: "grupo", label: "grupo", form:()=> 0 }, 
            { columna: "recording", label: "recording", form:()=> 1 },
          ]
        }
        id= "id_usuario"/*
        selected={(e)=>{
          const etiquetaTemp= stor.etiquetas_object.filter(et => et.id === e.idEtiqueta);
          if( etiquetaTemp.length !== 1){
            alert("Precaución la incidencia: \n"+ e.nombre + " \n No esta configurada para envío de notificaciones "+ "\n Contacta a sistemas");
          }
        }}*/
        csvname= {"extensiones"}
        /*
        resaltarFuncion={(e)=>{
          return incidencias.filter(i => i.incidencia.id === e.id  ).length ? true: false
        }}
        resaltarColor={(e)=>{
          const etiquetaTemp= stor.etiquetas_object.filter(et => et.id === e.idEtiqueta);
          if( etiquetaTemp.length !== 1){
            return "rgba(242, 151, 151, 0.41)";
          }
          return "rgba(58, 223, 149, 0.25)";
        }}*/
        paginacion={true}
        elementosPorPagina={15}
      />
    </SiteWrapper>
  );
}


export default MigrarExtensionesPage;